import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { RegulationGQL} from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-regulation',
    templateUrl: './regulation.component.html',
    styleUrls: ['./regulation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegulationComponent implements OnInit {

  regulation$: Observable<any> = of();
  constructor(private regulationGql: RegulationGQL) { }

  ngOnInit(): void {
    this.regulation$ = this.regulationGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return (response.data.regulation)
      })
    )
  }
}